'use client';

import React from 'react';
import { Box, MantineProvider } from '@mantine/core';
import SiteHeader from '@/components/SiteHeader';
import SiteFooter from '@/components/SiteFooter';
import HelpChangeSection from '@/components/HelpChangeSection';

interface ClientTermsLayoutProps {
    children: React.ReactNode;
}

const ClientTermsLayout: React.FC<ClientTermsLayoutProps> = ({ children }) => {
    return (
        <MantineProvider>
            <Box>
                <SiteHeader />
                {children}
                <HelpChangeSection />
                <SiteFooter />
            </Box>
        </MantineProvider>
    );
};

export default ClientTermsLayout; 